<template>
  <div class="container">
    <van-nav-bar fixed placeholder title="支付"/>
    <div class="top">
      <img src="@/assets/error.png" alt="">
      
      <div class="tip">支付失败</div>
      <!-- <div class="num">请重新支付</div> -->
      <div class="btn" @click="goBack">返回</div>
    </div>


  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {

      
    };
  },
  methods: {

    
    onClickLeft() {
      // this.$router.replace("/contribute");
      this.$router.replace('/');
    },
    goBack() {
      // this.$router.replace("/contribute");
      this.$router.replace('/order');
    },

  },
  mounted() {
    // this.$router.replace('/home');
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff !important;
  height: 100vh;
  position: relative;
  .top {
    width: 100%;
    // display: flex;
    // justify-content: center;
    text-align: center;
    img{
      width: 100%;
      padding: .4rem 1.6rem 0 1.6rem;
    }
    .tip{
      font-size: 17px;
      color: #666;
      margin-top: .4rem;
    }
    .num{
      font-size:17px;
      color:#666;
      margin-top: .4rem;
    }
    .btn{
      background: #ff991d;
      padding: .3rem .4rem;
      border-radius:1rem;
      margin: 1rem;
      color: #fff;
      font-size:18px;
    }
    
  }
}
</style>
